<template>  
<div> <!-- root element start -->

  <transition name="slide-fade" mode="out-in">
    <component 
      :is="mainView" 
      :prop1="mvProp1" 
      :prop2="mvProp2" 
      :prop3="mvProp3" 
      @onSComplete="successComplete" 
      @onUComplete="unsuccessComplete"
      @onSecondary="secondaryAction"
    >
    </component>
  </transition>

</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/product-builder-main-store.js'


import prodMain from '../productBuilderComponents/product-builder-main.vue'
import prodBuild from '../productBuilderComponents/product-builder-builder.vue'
import prodView from '../productBuilderComponents/product-builder-view.vue'


export default {
  store,
  data: function () {
    return { 
      
    }
  },
  computed: {
    mainView () { return this.$store.state.mainView },
    mvProp1 () { return this.$store.state.mvProp1 },
    mvProp2 () { return this.$store.state.mvProp2 },
    mvProp3 () { return this.$store.state.mvProp3 },
  },
  watch: {
    
  },
  mounted() {
    this.getAllProducts();
    this.getAllItems();
    this.getAllUserBuilds();
  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },
    getAllUserBuilds() { this.$store.dispatch("getAllUserBuilds") },
    getAllProducts() { this.$store.dispatch("getAllProducts") },
    getAllItems() { this.$store.dispatch("getAllItems") },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-builder':
        _this.getAllUserBuilds();
        _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-builder':
          _this.getMainView('product-main', '', '', '');
        break;
        case 'product-view':
          _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },
    secondaryAction(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-view':
        _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },

  },    
  components:{
    'product-main' : prodMain,
    'product-builder' : prodBuild,
    'product-view' : prodView,
  },
  filters: {

  }
}
</script>
